module.exports = __webpack_public_path__ + "static/img/u26.7392bb8b.webp";